import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';
import { LocalizedText } from 'bernie-l10n';

import { ReviewsViewModel } from 'models';

import { Reviews } from 'components/infosite/property-details/reviews';

interface HotelReviewProps {
  reviews: ReviewsViewModel;
  header: string;
}

const HotelReviews: React.FunctionComponent<HotelReviewProps> = ({ reviews, header }) => (
  <section>
    <h2 className="is-visually-hidden">
      <LocalizedText message={header} />
    </h2>
    <ErrorBoundary label="hotel.information.details.reviews">
      <Reviews reviews={reviews} />
    </ErrorBoundary>
  </section>
);

export { HotelReviews };
